import { Component, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'status-card',
    templateUrl: './status-card.component.html',
    styleUrl: './status-card.component.css',
    standalone: false
})
export class StatusCardComponent {
  @Input('cardColor') cardColor: string;
  @Input('backgroundColorIcon') backgroundColorIcon: string;
  @Input('iconName') iconName: string;
  @Input('cardTitle') cardTitle: string;
  @Input('buttonTitle') buttonTitle: string;
  @Input('loading') loading: Boolean;
  @Input('routingPath') routingPath: string;
  @Input('isShowTooltip') isShowTooltip: Boolean;
  @Input('toolTipContent') toolTipContent: Array<any> = [];
  @Input('isShowQuota') isShowQuota: any;

  statusCount: any;
  @Input('cardCount')
  public set value(v: string) {
    this.statusCount = this.formatToTwoDigits(v);
  }
  public get value(): string {
    return this.statusCount
  }

  constructor(private router: Router) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  formatToTwoDigits(value: number | string): string {
    // return String(value).padStart(2, '0');
    return String(value);
  }

  routeToFilterEmployee() {
    if (this.routingPath && typeof this.routingPath == "string") {
      if (this.routingPath.includes('&')) {
        let filter: string[] = this.routingPath.split('&');
        this.router.navigate(['/employees'], { queryParams: { filter: filter } });
        return;
      }
      this.router.navigate(['/employees'], { queryParams: { filter: this.routingPath } });
    }
  }

  routeEmployees(empId: any) {
    if (empId) {
      this.router.navigate(['/user-details/', empId]);
    }
  }
}
